const ufs = ['SP', 'RJ', 'MG', 'RS', 'PR', 'SC', 'BA', 'DF', 'GO', 'PE', 'PA', 'CE', 'ES', 'MT', 'AM', 'MS', 'MA', 'RN', 'PB', 'AL', 'PI', 'SE', 'RO', 'TO', 'AP', 'AC', 'RR',];

export const validUF = (data) => ufs.includes(data);
